import React from 'react';
import '../template-file-css/document-file-template.css';


import { AddGoalsUsingPatientList } from '../common-controlls/rendergoals-using-client';


export const GHP_CaBiopsychosocialTreatmentPlan = ({
    itemsRef,
    showErrorFor,
    selectedPatientList,
    isEdit,
    onGoalsDataStateChange,
    preselctedGoalEdit,
    isViewDoc,
    tpId,
    isDraft,
    draftCommonControlls
}) => {

    return (
        <form id='GHP_CaBiopsychosocialTreatmentPlan' className='file-pdf-document'>
            <div className='file-template'>

                <table>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Suicidal Ideation:</span></td>
                        <td className='w-375'><span className='eleHeader'>Homicidal Ideations:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSuicidalIdeation_Yes' name='rbSuicidalIdeation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSuicidalIdeation_No' name='rbSuicidalIdeation' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbHomicidalIdeations_Yes' name='rbHomicidalIdeations' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHomicidalIdeations_No' name='rbHomicidalIdeations' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If risk exists, Individual can contract not to harm:</span>
                    <input type='radio' id='rbContractNotHarm_Self' name='rbContractNotHarm' className='add-only' value='Self' /> Self &nbsp;
                    <input type='radio' id='rbContractNotHarm_Others' name='rbContractNotHarm' className='add-only' value='Others' /> Others

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Hopes:</span>
                    <textarea id='txtHopes' name='txtHopes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Choices:</span>
                    <textarea id='txtChoices' name='txtChoices' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea id='txtPreferences' name='txtPreferences' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Desired Outcomes:</span>
                    <textarea id='txtDesiredOutcomes' name='txtDesiredOutcomes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Stage of Change:</span>
                    <input type='checkbox' id='cbStageChange_1' name='cbStageChange_1' className='add-only' value='StageChange_1' /> Pre-Contemplation  &nbsp;
                    <input type='checkbox' id='cbStageChange_2' name='cbStageChange_2' className='add-only' value='StageChange_2' /> Contemplation  &nbsp;
                    <input type='checkbox' id='cbStageChange_3' name='cbStageChange_3' className='add-only' value='StageChange_3' /> Preparation  &nbsp;
                    <input type='checkbox' id='cbStageChange_4' name='cbStageChange_4' className='add-only' value='StageChange_4' /> Action  &nbsp;
                    <input type='checkbox' id='cbStageChange_5' name='cbStageChange_5' className='add-only' value='StageChange_5' /> Maintenance  &nbsp;
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Individual/Family was an active participant in the development of the service plan and identified the goals listed below::</span>
                    <input type='radio' id='rbIdentifiedTheGoals_Yes' name='rbIdentifiedTheGoals' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIdentifiedTheGoals_No' name='rbIdentifiedTheGoals' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Need/Problem:</span>
                    Whole Health (Psychiatry/Medical) (Do not change goal one, codes or frequencies)
                    <textarea id='txtNeedProblem' name='txtNeedProblem' className='add-only'></textarea>
                </p>



                {/* Goal Section */}

                <div>
                    <AddGoalsUsingPatientList
                        isEdit={isEdit}
                        preselctedGoalEdit={preselctedGoalEdit}
                        selectedPatientList={selectedPatientList}
                        onDataStateChange={onGoalsDataStateChange}
                        isViewDoc={isViewDoc}
                        tpIdNumber={tpId}
                        isDraft={isDraft}
                        draftCommonControlls={draftCommonControlls}
                    />
                </div>

                <p className='w-750'>
                    <b>
                        <center>
                            TRANSITION /DISCHARGE PLAN
                            <br />
                            (Step down service should be a non-CORE related service [i.e, Med Mgmt., Support Group, Mentoring Program etc.]
                            Must be written in S.M.A.R.T format)
                        </center>

                    </b>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'> Projected Date of Discharge/Transition:</span>
                    <input type='date' id='txtProjectedDate' name='txtProjectedDate' className='add-only w-375  ' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Individual will step down over the course of treatment in the following manner:</span>
                    <ul>
                        <li><b>Individual Skills Services:</b> Taper down from 1-2x weekly to 2x monthly, then 1x monthly</li>
                        <li><b>Individual Therapy:</b> Taper down from Warren therapy 1x weekly to 2x per month, etc.</li>
                        <li><b>Family Therapy:</b> Taper down from 3 sessions per month to once a month for family management</li>
                        <li><b>Family Skills  Services:</b> Taper down from 4 sessions per month; to twice a month; to once a month to continue encouraging efficient family communication and function</li>
                        <li><b>Case Management:</b> Taper down from 4 times a month to twice a month and eventually as needed for social and medical management</li>
                        <li><b>Medication Management and Administration Treatment:</b> Continue as needed and as instructed by Psychiatrist or ARNP</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Maintenance Recommendation:</span>
                    <textarea id='txtMaintenanceRecommendation' name='txtMaintenanceRecommendation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Plans for Transition/Discharge:</span>
                    <textarea id='txtPlansTransitionDischarge' name='txtPlansTransitionDischarge' className='add-only'></textarea>
                </p>




                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Individual Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Individual Printed Name: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>
                        COMPLETED BY:
                        <br />
                        <span className='small'>(Please include credentials after your name)</span>
                    </b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Assessor Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Assessor Print Name: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>
                        REVIEWED BY (if applicable):
                        <br />
                        <span className='small'>(Please include credentials after your name)</span>
                    </b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Licensed Professional Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Licensed Professional Print Name: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}